<template>
  <div class="survey-box">
    <div class="subject-box">
      <div class="survey-title">【{{surveyTitle}}】详情</div>
      <div class="title-box" >
        <div class="title-config"><span class="title-block"></span>问卷题目</div>
      </div>
      <div v-for="(item, index) in subjectList" :key="index">
        <!-- 单选题 -->
        <div class="subject-box-list" v-show="item.subjectType == '单选题'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-radio-group class="subject-group" v-model="item.inputText" style="line-height: 45px" disabled>
            <el-radio
              class="subject-radio mb20 mt15"
              v-for="(items, index1) in item.selectItems"
              :key="index1"
              :label="items.text"
            ></el-radio>
          </el-radio-group>
        </div>
        <!-- 多选题 -->
        <div class="subject-box-list" v-show="item.subjectType == '多选题'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-checkbox-group disabled class="subject-group" v-model="item.valueSelect" style="line-height: 45px">
            <el-checkbox
              class="subject-radio"
              v-for="(items, index1) in item.selectItems"
              :key="index1"
              :label="items.text"
            ></el-checkbox>
          </el-checkbox-group>
        </div>
        <!-- 单行填空题 -->
        <div class="subject-box-list" v-show="item.subjectType == '单行填空题'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-input class="ml20 w49f" disabled type="input" placeholder="请输入" v-model="item.inputText" />
        </div>
        <!-- 多行填空题 -->
        <div class="subject-box-list" v-show="item.subjectType == '多行填空题'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-input
            disabled
            class="ml20 w96f"
            type="textarea"
            placeholder="请输入"
            :rows="5"
            v-model="item.inputText"
          />
        </div>
        <!-- 选择区域 -->
        <div class="subject-box-list" v-show="item.subjectType == '选择区域'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-select disabled class="w30f ml20" v-model="value" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
        <!-- 调研对象 -->
        <div class="subject-box-list" v-show="item.subjectType == '调研对象'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-radio-group class="subject-group" v-model="item.inputText" style="line-height: 45px" disabled>
            <el-radio
              class="subject-radio mb20 mt15"
              v-for="(items, index1) in item.selectItems"
              :key="index1"
              :label="items.text"
            ></el-radio>
          </el-radio-group>
        </div>
        <!-- 客户名称 -->
        <div class="subject-box-list" v-show="item.subjectType == '客户名称'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-select disabled class="w30f ml20" v-model="value" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
        <!-- 年月日（日期选择） -->
        <div class="subject-box-list" v-show="item.subjectType == '年月日'">
          <div class="subject-list-title">
            <div class="subject-title-left">
              <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                item.subjectTitle
              }}
            </div>
          </div>
          <el-date-picker
            disabled
            class="w30f ml20"
            type="date"
            placeholder="请选择日期"
            v-model="item.inputText"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return{
      subjectList:[],
      surveyTitle:'',
      options:[],
      value:''
    }
  },
  created() {
    if(sessionStorage.surveyData){
      let surveyData = JSON.parse(sessionStorage.surveyData);
      this.subjectList = surveyData.subjectList;
      this.surveyTitle = surveyData.surveyTitle;
    }
  },
  methods: {
    
  },
};
</script>
<style  scoped>
.survey-box{
  padding: 12px 17%;
  border-radius: 4px;
}
.survey-title{
  font-size: 18px;
  text-align: center;
}
/* 题目列表 */
.subject-box {
  padding: 30px 140px;
  box-sizing: border-box;
  background: #fff;
}
.subject-box-list {
  text-align: left;
  padding: 30px 0 30px 20px;
  border-bottom: 1px solid #e3e3e3;
}
.subject-title-left span{
  color: red;
}
.subject-title-right {
  flex-shrink: 0;
  font-size: 14px;
}
.subject-title-right span {
  color: #649fa4;
  cursor: pointer;
}
.subject-list-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.subject-title-del {
  color: #676767 !important;
}
.subject-title-line {
  color: #c8c9cc !important;
}
.subject-group {
  display: flex;
  flex-flow: column;
  padding-left: 20px;
}
.subject-radio {
  margin-bottom: 10px;
}
.title-box {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-right: 20px;
  padding-top: 40px;
}
.title-config .title-block {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}
</style>